/*
 * @Author: kiwi_myl
 * @Description: Do not edit
 * @Date: 2020-11-06 11:36:44
 * @LastEditTime: 2021-04-16 08:45:08
 * @FilePath: /wedsVue/visito/src/api/base.ts
 */


// dev test pre qinhuangdao prod prod_lida prod_huailai master_private
let BUILD_ENV = 'prod';
// 开发版 dev wx6a81ae0838b25eda
// 校园足迹 test appid:wx4294667ee315a00a
// pre测试版 pre wxb8c5ba65b56137db
// 校园足记 li：wxadd3dfdf9921f540
const PROD_JAVA = 'https://www.12kcool.com/app/bepf/'
const PROD_JAVAS = 'https://www.12kcool.com/core/bepf/'
const PROD_NODEnode = 'https://www.12kcool.com/'
const PROD_NODE = 'https://www.12kcool.com/api/v2/'
const PROD_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21'
const PROD_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw'
//yali appid:wx1e9641ea06b84e5c
/* 版本更新时候 需要修改的地方
1.上传图片视频域名更改
2.mian 域名更改
3.人脸采集域名更改
 */
/* const PROD_JAVAS = 'https://xzx.yali.edu.cn/core/bepf/'
const PROD_JAVA = 'https://xzx.yali.edu.cn/app/bepf/'
const PROD_NODE = 'https://xzx.yali.edu.cn/api/v2/'
const PROD_NODEnode = 'https://xzx.yali.edu.cn/' */
//dev
const DEV_JAVA = 'https://www-dev.12kcool.com/app/bepf/'
const DEV_JAVAS = 'https://www-dev.12kcool.com/core/bepf/'
const DEV_NODE = 'https://www-dev.12kcool.com/api/v2/'
const DEV_NODEnode = 'https://www-dev.12kcool.com/'
const DEV_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21'
const DEV_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw'
//pre

const PRE_JAVA = 'https://wxk12-pre.weds.cn/app/bepf/'
const PRE_JAVAS = 'https://wxk12-pre.weds.cn/core/bepf/'
const PRE_NODE = 'https://wxk12-pre.weds.cn/api/v2/'
const PRE_NODEnode = 'https://wxk12-pre.weds.cn/'
const PRE_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21'
const PRE_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw'

// test
const TEST_NODEnode = 'https://www-test.12kcool.com/'
const TEST_NODE = 'https://www-test.12kcool.com/api/v2/'
const TEST_JAVA = 'https://www-test.12kcool.com/app/bepf/'
const TEST_JAVAS = 'https://www-test.12kcool.com/core/bepf/'
const TEST_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21'
const TEST_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw'

// qinhuangdao
const QINHUANGDAO_NODEnode = 'https://wxk12.icbcedu.com/'
const QINHUANGDAO_NODE = 'https://wxk12.icbcedu.com/api/v2/'
const QINHUANGDAO_JAVA = 'https://wxk12.icbcedu.com/app/bepf/'
const QINHUANGDAO_JAVAS = 'https://wxk12.icbcedu.com/core/bepf/'
const QINHUANGDAO_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21'
const QINHUANGDAO_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw'

// minio-怀来 prod_huailai
const PROD_HUAILAI_NODEnode = 'https://http://120.211.237.132:28080/'
const PROD_HUAILAI_NODE = 'https://http://120.211.237.132:28080/api/v2/'
const PROD_HUAILAI_JAVA = 'https://http://120.211.237.132:28080/app/bepf/'
const PROD_HUAILAI_JAVAS = 'https://http://120.211.237.132:28080/core/bepf/'
const PROD_HUAILAI_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21'
const PROD_HUAILAI_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw'

// 本地化部署 - 利达 - prod_lida
const PROD_LIDA_NODEnode = 'https://lida.12kcool.com/'
const PROD_LIDA_NODE = 'https://lida.12kcool.com/api/v2/'
const PROD_LIDA_JAVA = 'https://lida.12kcool.com/app/bepf/'
const PROD_LIDA_JAVAS = 'https://lida.12kcool.com/core/bepf/'
const PROD_LIDA_FACE_KEY = 'AmmCWU49PUgL4d1oJvuYSYygFdzLm6-J'
const PROD_LIDA_FACE_SECRET = 'pKwIa3zZlrO6FMafmNPoj2vtlhostUvp'

const origin = location.origin
// 本地化部署 - master_private
const MASTER_PRIVATE_NODEnode = `${origin}/`
const MASTER_PRIVATE_NODE = `${origin}/api/v2/`
const MASTER_PRIVATE_JAVA = `${origin}/app/bepf/`
const MASTER_PRIVATE_JAVAS = `${origin}/core/bepf/`
// const MASTER_PRIVATE_FACE_KEY = 'v0wl5x8gQLgdnp17gLEHe-ziGicooh5j' // 天方
// const MASTER_PRIVATE_FACE_SECRET = 'vs-dXLNOwvrantUbBHuY3AMpqJl5xufG' // 天方
// const MASTER_PRIVATE_FACE_KEY = 'v0wl5x8gQLgdnp17gLEHe-ziGicooh51' // 新疆瀚海
// const MASTER_PRIVATE_FACE_SECRET = 'vs-dXLNOwvrantUbBHuY3AMpqJl5xuf1' // 新疆瀚海
const MASTER_PRIVATE_FACE_KEY = 'iSTKXqDMhj8wz3QOEI9bVtruDbsd7G21' // 其他
const MASTER_PRIVATE_FACE_SECRET = 'tLL4a8QLwOJf2FIJXL_3OumQjP_5wKnw' // 其他


const BASE = {
  qiNiu: 'https://upload.qiniup.com/',
  picHost: BUILD_ENV === 'prod' ? 'https://res-k12.12kcool.com/' :
    'https://res-mal.12kcool.com/',
  alis: BUILD_ENV === 'dev'
    ? DEV_JAVAS :
    BUILD_ENV === 'test'
      ? TEST_JAVAS :
      BUILD_ENV === 'qinhuangdao'
        ? QINHUANGDAO_JAVAS :
        BUILD_ENV === 'prod_lida'
          ? PROD_LIDA_JAVAS :
          BUILD_ENV === 'prod_huailai'
            ? PROD_HUAILAI_JAVAS :
            BUILD_ENV === 'pre'
              ? PRE_JAVAS :
              BUILD_ENV === 'master_private'
                ? MASTER_PRIVATE_JAVAS :
                PROD_JAVAS,
  ali: BUILD_ENV === 'dev'
    ? DEV_JAVA :
    BUILD_ENV === 'test'
      ? TEST_JAVA :
      BUILD_ENV === 'qinhuangdao'
        ? QINHUANGDAO_JAVA :
        BUILD_ENV === 'prod_lida'
          ? PROD_LIDA_JAVA :
          BUILD_ENV === 'prod_huailai'
            ? PROD_HUAILAI_JAVA :
            BUILD_ENV === 'pre'
              ? PRE_JAVA :
              BUILD_ENV === 'master_private'
                ? MASTER_PRIVATE_JAVA :
                PROD_JAVA,
  gateway:
    BUILD_ENV === 'dev'
      ? DEV_NODE :
      BUILD_ENV === 'test'
        ? TEST_NODE :
        BUILD_ENV === 'qinhuangdao'
          ? QINHUANGDAO_NODE :
          BUILD_ENV === 'prod_lida'
            ? PROD_LIDA_NODE :
            BUILD_ENV === 'prod_huailai'
              ? PROD_HUAILAI_NODE :
              BUILD_ENV === 'pre'
                ? PRE_NODE :
                  BUILD_ENV === 'master_private'
                    ? MASTER_PRIVATE_NODE : PROD_NODE,
  gateways:
    BUILD_ENV === 'dev'
      ? DEV_NODEnode
      : BUILD_ENV === 'test'
        ? TEST_NODEnode
        : BUILD_ENV === 'qinhuangdao'
          ? QINHUANGDAO_NODEnode
          : BUILD_ENV === 'prod_lida'
            ? PROD_LIDA_NODEnode
            : BUILD_ENV === 'prod_huailai'
              ? PROD_HUAILAI_NODEnode
              : BUILD_ENV === 'pre' 
                ? PRE_NODEnode : 
                  BUILD_ENV === 'master_private' 
                  ? MASTER_PRIVATE_NODEnode : PROD_NODEnode,
  faceKey:
    BUILD_ENV === 'dev'
      ? DEV_FACE_KEY
      : BUILD_ENV === 'test'
        ? TEST_FACE_KEY
        : BUILD_ENV === 'qinhuangdao'
          ? QINHUANGDAO_FACE_KEY
          : BUILD_ENV === 'prod_lida'
            ? PROD_LIDA_FACE_KEY
            : BUILD_ENV === 'prod_huailai'
              ? PROD_HUAILAI_FACE_KEY
                : BUILD_ENV === 'pre' 
              ? PRE_FACE_KEY
                : BUILD_ENV === 'master_private' 
                ? MASTER_PRIVATE_FACE_KEY : PROD_FACE_KEY,
  faceSecret:
    BUILD_ENV === 'dev'
      ? DEV_FACE_SECRET
      : BUILD_ENV === 'test'
        ? TEST_FACE_SECRET
        : BUILD_ENV === 'qinhuangdao'
          ? QINHUANGDAO_FACE_SECRET
          : BUILD_ENV === 'prod_lida'
            ? PROD_LIDA_FACE_SECRET
            : BUILD_ENV === 'prod_huailai'
              ? PROD_HUAILAI_FACE_SECRET
              : BUILD_ENV === 'pre' 
                ? PRE_FACE_SECRET
                  : BUILD_ENV === 'master_private' 
                  ? MASTER_PRIVATE_FACE_SECRET : PROD_FACE_SECRET,
  survey: 'api/web/question/', // 问卷调查
  // resource: 'api/resource/', // 资源
  resource: 'resource/', // 资源
  timetable: 'edu/report/', // 课表
  place: 'api/', // 场所
  brandMessage: 'inform/leave_message/', // 班牌留言
  moral: 'bepf/education/', // 德育宣传
  homework: 'inform/assignment/', // 家庭作业
  brandTemplate: 'template/', // 班牌模板
  notice: 'inform/notice/', // 通知相关接口
  wechat: 'api/v2/wechat/',
  visitor: 'visit/v1/', // 访客相关
  bepf: 'api/bepf/'// 访客相关
}

export default BASE

